import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Check, X } from 'lucide-react';
import { market } from '../lib/api';

function ListingRow({ cp, onDone }) {
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);
  const decide = async (decision) => {
    setBusy(true);
    try { await market.adminCatalogDecide(cp.id, decision, note); toast.success('Saved'); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid={`catalog-pending-${cp.id}`} className="card-soft p-4 flex flex-col md:flex-row gap-4">
      <img src={cp.images?.[0]} alt={cp.name} className="w-24 h-24 rounded-lg object-cover bg-sand"/>
      <div className="flex-1 space-y-1 text-sm">
        <div className="font-heading font-bold">{cp.name}</div>
        <div className="text-ink/70">{cp.brand}{cp.manufacturer ? ` · by ${cp.manufacturer}` : ''} · {cp.category}</div>
        <div>MRP ₹{cp.mrp} · GST {cp.gst_rate}% · HSN {cp.hsn} · Origin {cp.country_of_origin}{cp.barcode ? ` · Barcode ${cp.barcode}` : ''}</div>
        {cp.warranty && <div>Warranty: {cp.warranty}</div>}
        <div className="text-xs text-ink/60">Seller: {cp.seller?.name || '—'} ({cp.seller?.seller_type || 'seller'}) · {cp.seller?.phone}</div>
        {cp.status === 'pending' && (
          <div className="flex flex-wrap gap-2 pt-2">
            <input data-testid="catalog-decision-note" value={note} onChange={e => setNote(e.target.value)} placeholder="Note (needed to reject)" className="flex-1 min-w-[180px] rounded-lg border border-border px-3 py-1.5 text-sm"/>
            <button data-testid="catalog-approve" disabled={busy} onClick={() => decide('approve')} className="btn-primary !bg-[#1B5E20] !border-[#1B5E20] text-sm"><Check className="w-4 h-4"/>Approve</button>
            <button data-testid="catalog-reject" disabled={busy} onClick={() => decide('reject')} className="btn-outline !text-[#B71C1C] !border-[#B71C1C] text-sm"><X className="w-4 h-4"/>Reject</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default function AdminCatalogApprovals() {
  const [status, setStatus] = useState('pending');
  const [items, setItems] = useState(null);
  const load = useCallback(() => market.adminCatalog(status).then(d => setItems(d.items)).catch(() => setItems([])), [status]);
  useEffect(() => { load(); }, [load]);
  return (
    <section data-testid="admin-catalog-approvals" className="space-y-3">
      <div className="flex gap-2">
        {['pending', 'approved', 'rejected'].map(s => (
          <button key={s} data-testid={`catalog-filter-${s}`} onClick={() => setStatus(s)} className={`rounded-full border px-3 py-1 text-sm capitalize ${status === s ? 'bg-ink text-white border-ink' : 'bg-white border-border'}`}>{s}</button>
        ))}
      </div>
      {items === null ? <Loader2 className="w-5 h-5 animate-spin"/> : items.length === 0 ? <p className="text-sm text-ink/60" data-testid="catalog-pending-empty">No listings here.</p>
        : items.map(cp => <ListingRow key={cp.id} cp={cp} onDone={load}/>)}
    </section>
  );
}
